import { action } from "./actionCreator";

export const PRESENCE_GET_DETAILS_WEEK = "presence/GET_DETAILS_WEEK";
export const PRESENCE_SET_DETAILS_WEEK = "presence/SET_DETAILS_WEEK";
export const PRESENCE_SET_DETAIL_WEEK_IS_LOADING = "presence/SET_DETAIL_WEEK_IS_LOADING";
export const PRESENCE_SET_ONE_WEEK_IS_LOADING = "presence/PRESENCE_SET_ONE_WEEK_IS_LOADING";

export const PRESENCE_UPDATE_ATTENDANCE_DETAILS_WEEK = "presence/UPDATE_ATTENDANCE_DETAILS_WEEK";
export const PRESENCE_SET_ATTENDANCE_UPDATED_DETAILS_WEEK = "presence/SET_ATTENDANCE_UPDATED_DETAILS_WEEK";
export const PRESENCE_SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_WEEK = "presence/SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_WEEK";
export const PRESENCE_RESET_ATTENDANCE_ERRORS_DETAILS_WEEK = "presence/RESET_ATTENDANCE_ERRORS_DETAILS_WEEK";

export const PRESENCE_UPDATE_MEAL_PACKAGE_DETAILS_WEEK = "presence/UPDATE_MEAL_PACKAGE_DETAILS_WEEK";
export const PRESENCE_SET_MEAL_PACKAGE_UPDATED_DETAILS_WEEK = "presence/SET_MEAL_PACKAGE_UPDATED_DETAILS_WEEK";
export const PRESENCE_SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_WEEK =
  "presence/SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_WEEK";
export const PRESENCE_RESET_MEAL_PACKAGE_ERRORS_DETAILS_WEEK = "presence/RESET_MEAL_PACKAGE_ERRORS_DETAILS_WEEK";

export const PRESENCE_UPDATE_TRIP_DETAILS_WEEK = "presence/UPDATE_TRIP_DETAILS_WEEK";
export const PRESENCE_SET_TRIP_UPDATED_DETAILS_WEEK = "presence/SET_TRIP_UPDATED_DETAILS_WEEK";
export const PRESENCE_SET_TRIP_UPDATE_ERRORS_DETAILS_WEEK = "presence/SET_TRIP_UPDATE_ERRORS_DETAILS_WEEK";
export const PRESENCE_RESET_TRIP_ERRORS_DETAILS_WEEK = "presence/RESET_TRIP_ERRORS_DETAILS_WEEK";

export const PRESENCE_SET_VALIDATE_TRIPS_WEEK = "presence/SET_VALIDATE_TRIPS_WEEK";
export const PRESENCE_SET_VALIDATE_TRIPS_SUCCESS_WEEK = "presence/SET_VALIDATE_TRIPS_SUCCESS_WEEK";
export const PRESENCE_SET_VALIDATE_TRIPS_FAILURE_WEEK = "presence/SET_VALIDATE_TRIPS_FAILURE_WEEK";
export const PRESENCE_RESET_TRIPS_VALIDATION_SUCCESS_WEEK = "presence/PRESENCE_RESET_TRIPS_VALIDATION_SUCCESS_WEEK";
export const PRESENCE_RESET_TRIPS_VALIDATION_FAILURE_WEEK = "presence/PRESENCE_RESET_TRIPS_VALIDATION_FAILURE_WEEK";

export const PRESENCE_SET_VALIDATE_ATTENDANCE_WEEK = "presence/SET_VALIDATE_ATTENDANCE_WEEK";
export const PRESENCE_SET_VALIDATE_ATTENDANCE_SUCCESS_WEEK = "presence/SET_VALIDATE_ATTENDANCE_SUCCESS_WEEK";
export const PRESENCE_SET_VALIDATE_ATTENDANCE_FAILURE_WEEK = "presence/SET_VALIDATE_ATTENDANCE_FAILURE_WEEK";
export const PRESENCE_RESET_ATTENDANCE_VALIDATION_SUCCESS_WEEK =
  "presence/PRESENCE_RESET_ATTENDANCE_VALIDATION_SUCCESS_WEEK";
export const PRESENCE_RESET_ATTENDANCE_VALIDATION_FAILURE_WEEK =
  "presence/PRESENCE_RESET_ATTENDANCE_VALIDATION_FAILURE_WEEK";

export const PRESENCE_SET_VALIDATE_MEAL_PACKAGES_WEEK = "presence/SET_VALIDATE_MEAL_PACKAGES_WEEK";
export const PRESENCE_SET_VALIDATE_MEAL_PACKAGES_SUCCESS_WEEK = "presence/SET_VALIDATE_MEAL_PACKAGES_SUCCESS_WEEK";
export const PRESENCE_SET_VALIDATE_MEAL_PACKAGES_FAILURE_WEEK = "presence/SET_VALIDATE_MEAL_PACKAGES_FAILURE_WEEK";
export const PRESENCE_RESET_MEAL_PACKAGES_VALIDATION_SUCCESS_WEEK =
  "presence/PRESENCE_RESET_MEAL_PACKAGES_VALIDATION_SUCCESS_WEEK";
export const PRESENCE_RESET_MEAL_PACKAGES_VALIDATION_FAILURE_WEEK =
  "presence/PRESENCE_RESET_MEAL_PACKAGES_VALIDATION_FAILURE_WEEK";

export const PRESENCE_ERASE_DETAILS_WEEK = "PRESENCE_ERASE_DETAILS_WEEK";
export const PRESENCE_ERASE_DETAILS_DAY = "PRESENCE_ERASE_DETAILS_DAY";
export const PRESENCE_UPDATE_DAY = "PRESENCE_UPDATE_DAY";

export const getPresenceDetailsWeek = payload => {
  return action(PRESENCE_GET_DETAILS_WEEK, { payload });
};

export const getPresenceDataOfTheDay = payload => {
  return action(PRESENCE_UPDATE_DAY, { payload });
};

export const updatePresenceAttendance = payload => {
  return action(PRESENCE_UPDATE_ATTENDANCE_DETAILS_WEEK, { payload });
};

export const resetPresenceAttendanceErrors = () => {
  return action(PRESENCE_RESET_ATTENDANCE_ERRORS_DETAILS_WEEK, {});
};

export const updatePresenceMealPackage = payload => {
  return action(PRESENCE_UPDATE_MEAL_PACKAGE_DETAILS_WEEK, { payload });
};

export const resetPresenceMealPackageErrors = () => {
  return action(PRESENCE_RESET_MEAL_PACKAGE_ERRORS_DETAILS_WEEK, {});
};

export const updatePresenceTrip = payload => {
  return action(PRESENCE_UPDATE_TRIP_DETAILS_WEEK, { payload });
};

export const resetPresenceTripErrors = () => {
  return action(PRESENCE_RESET_TRIP_ERRORS_DETAILS_WEEK, {});
};

export const validatePresenceTripsWeeks = payload => {
  return action(PRESENCE_SET_VALIDATE_TRIPS_WEEK, { payload });
};

export const resetPresenceTripsValidationSuccess = () => {
  return action(PRESENCE_RESET_TRIPS_VALIDATION_SUCCESS_WEEK, {});
};

export const resetPresenceTripsValidationFailure = () => {
  return action(PRESENCE_RESET_TRIPS_VALIDATION_FAILURE_WEEK, {});
};

export const validatePresenceAttendancesWeek = payload => {
  return action(PRESENCE_SET_VALIDATE_ATTENDANCE_WEEK, { payload });
};

export const resetPresenceAttendanceSuccess = () => {
  return action(PRESENCE_RESET_ATTENDANCE_VALIDATION_SUCCESS_WEEK, {});
};

export const resetPresenceAttendanceFailure = () => {
  return action(PRESENCE_RESET_ATTENDANCE_VALIDATION_FAILURE_WEEK, {});
};

export const validatePresenceMealPackagesWeek = payload => {
  return action(PRESENCE_SET_VALIDATE_MEAL_PACKAGES_WEEK, { payload });
};

export const resetPresenceMealPackagesValidationSuccess = () => {
  return action(PRESENCE_RESET_MEAL_PACKAGES_VALIDATION_SUCCESS_WEEK, {});
};

export const resetPresenceMealPackagesValidationFailure = () => {
  return action(PRESENCE_RESET_MEAL_PACKAGES_VALIDATION_FAILURE_WEEK, {});
};



// WEBPACK FOOTER //
// src/modules/presence/actions/presenceDetailsWeek.js